import React, { type ReactNode } from 'react';
import type { FieldType } from '@/types/EvalancheTypes';
import { Container, Input, FormLabel, ErrorMessage } from '../styles';
import { isValidDateFormat } from 'service/date/isValidDateFormat';

const dateType = (widgetId: number): string => {
  if (widgetId === 7 || widgetId === 17 || widgetId === 30 || widgetId === 20 || widgetId === 37) {
    return 'datetime-local';
  }
  return 'date';
};

export const DateInput = ({
  field,
  formikProps,
}: {
  field: FieldType;
  formikProps: any;
}): ReactNode => {
  const fieldValue = formikProps.values[field.name];
  const validValue = isValidDateFormat(fieldValue) ? fieldValue : '';

  return (
    <Container>
      <FormLabel tag="span" type="lead" className="text-gray-500">
        {field.label}
      </FormLabel>
      <Input
        type={dateType(field.widget_id)}
        name={field.name}
        onChange={formikProps.handleChange}
        value={validValue}
        hidden={field.hidden}
        required={field.required}
        data-test={`date-${field.name}`}
      />
      {formikProps.errors[field.name] && (
        <ErrorMessage data-test={`date-${field.name}-error`}>
          {formikProps.errors[field.name]}
        </ErrorMessage>
      )}
    </Container>
  );
};
